import React, { useState, useEffect } from "react";
import styles from "./AboutUs.module.css";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import Button from "@mui/material/Button";
import ModalVideo from "react-modal-video";

function AboutUs(props) {
  const { teachingInfo } = props;

  const [videoId, setVideoId] = useState("");

  useEffect(() => {
    if (teachingInfo?.videoUrl != "") {
      let vid = getYouTubeVideoId(teachingInfo?.videoUrl);
      setVideoId(vid);
    } else {
      setVideoId("");
    }
  }, [teachingInfo]);

  const [isOpen, setOpen] = useState(false);

  const getYouTubeVideoId = (url) => {
    try {
      const parsedUrl = new URL(url);

      // youtu.be/<id>
      if (parsedUrl.hostname === "youtu.be") {
        return parsedUrl.pathname.slice(1);
      }

      // youtube.com/watch?v=<id>
      if (parsedUrl.searchParams.has("v")) {
        return parsedUrl.searchParams.get("v");
      }

      // youtube.com/embed/<id>
      const match = parsedUrl.pathname.match(/\/embed\/([^/?]+)/);
      if (match) {
        return match[1];
      }

      return null;
    } catch {
      return null;
    }
  };

  return (
    <div className={styles.MainSection} id="about">
      <div className={styles.Container}>
        <div className={styles.ContentContainer}>
          <div className={styles.AboutTitleMobile}>About</div>
          <div className={styles.UserCard}>
            <div className={styles.UserCardImg}>
              <img
                className={styles.UserImge}
                // src="https://cdn.mytakbir.com/static-assets/images/teaching-about-img.png"
                src={teachingInfo?.aboutImageUrl}
              />
              {teachingInfo?.videoUrl && teachingInfo?.videoUrl != "" && (
                <Button
                  variant="text"
                  className={styles.PlayButton}
                  onClick={() => setOpen(true)}
                >
                  <PlayArrowRoundedIcon />
                </Button>
              )}
            </div>

            <div className={styles.UserName}>{teachingInfo?.aboutTitle}</div>
            <div className={styles.UserDesignation}>
              {teachingInfo?.subtitle}
            </div>
            {/* <div className={styles.UserDescripton}>
              World Muslim Heritage Research Center
            </div> */}
          </div>

          <div className={styles.UserCardTextSection}>
            <div className={styles.AboutTitle}>About</div>
            <div
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html: teachingInfo?.about,
              }}
            />
          </div>
        </div>
      </div>

      <ModalVideo
        channel="youtube"
        youtube={{ mute: 0, autoplay: 0 }}
        isOpen={isOpen}
        videoId={videoId}
        onClose={() => setOpen(false)}
      />
    </div>
  );
}

export default AboutUs;
